import { useParams } from 'react-router-dom';
import { EmployeeDetails } from '../components/EmployeeDetails';
import { useQuery } from 'react-query';
import timeaway from '../../../network/timeaway';
import { Spinner } from '../../../ui/Spinner';
import { RiErrorWarningLine } from '@remixicon/react';
import { Card, Text, Title } from '@tremor/react';

export function EmployeeDetailsRoute() {
  const { id } = useParams<{ id: string }>();

  const { data: timeawayData, isLoading, isError } = useQuery(
    ['timeaway-details', id],
    () => timeaway.getEmployeeDetails(id!),
    {
      enabled: !!id,
      retry: false,
    }
  );

  if (isLoading) {
    return (
      <div className="flex h-[75vh] flex-col items-center justify-center gap-3">
        <Spinner size={10} className="text-red-500" />
        <p className="font-semibold">Loading...</p>
      </div>
    );
  }

  // Check for error OR missing data OR essential fields missing in the data
  const essentialDataMissing = !timeawayData?.data ||
                               !timeawayData.data.applicant ||
                               !timeawayData.data.start_date ||
                               !timeawayData.data.end_date ||
                               !timeawayData.data.days_requested ||
                               !timeawayData.data.type;

  if (isError || essentialDataMissing) {
    return (
      <div className="flex h-[75vh] items-center justify-center p-4">
        <Card className="max-w-lg text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <RiErrorWarningLine
              className="h-6 w-6 text-red-600"
              aria-hidden="true"
            />
          </div>
          <Title className="mb-2">Request Not Found</Title>
          <Text>
            This time away request does not exist or could not be loaded. It
            might have been deleted, lack essential information, or the link may be incorrect.
          </Text>
        </Card>
      </div>
    );
  }

  // Only render if loading is done, no error, and essential data exists
  return <EmployeeDetails currentUser={timeawayData.data} />;
} 